import React, { forwardRef, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import { Fade } from "@mui/material";
import theme from "../theme";
import { Box } from "@mui/system";
import { TitleAdmin } from "./TitleAdmin";

const PageAdmin = forwardRef(({ children, title = "", button, icon, noMargin, ...rest }, ref) => {
	const [appear, setApperar] = useState(false);
	useEffect(() => {
		window.scrollTo(0, 0);
		setTimeout(() => {
			setApperar(true);
		}, 300);
	}, []);

	return (
		<div
			ref={ref}
			{...rest}
			style={{
				position: "relative",
			}}
		>
			<Helmet>
				<title>Patum Infantil - {title}</title>
			</Helmet>
			<TitleAdmin button={button} icon={icon}>
				{title}
			</TitleAdmin>
			<Fade in={appear} timeout={400}>
				<div
					style={{
						overflow: "hidden",
					}}
				>
					<Box mt={10} zIndex={0}>
						{children}
					</Box>
				</div>
			</Fade>
		</div>
	);
});

PageAdmin.propTypes = {
	children: PropTypes.node.isRequired,
	title: PropTypes.string,
	button: PropTypes.object,
};

export default PageAdmin;
